var store = require('store')

export default function formChangeHandler(form){
    //restore saved values
    populateForm();
    let inputs = form.getElementsByTagName("input"); 
    for (let index = 0; index < inputs.length; index++){
        inputs[index].onchange = function(){
            saveForm(form);
        }
    }
    inputs = form.getElementsByTagName("select"); 
    for (let index = 0; index < inputs.length; index++){
        inputs[index].onchange = function(){
            saveForm(form);
        }
    }
};

function saveForm(form){
    const formValues = new FormData(form);
    //Cookies.set('formValues', JSON.stringify(formValues.entries()), { expires: 7 });
    let values = {};
    for (var pair of formValues.entries()) {
        values[pair[0]] = pair[1]; 
    }
    store.set('formValues', values);
}

function populateForm(){
    //populate form with previous details
    let formValues = store.get('formValues');
    //console.log(formValues);
    if( formValues ) {
        const keys = Object.keys(formValues)
        for (const key of keys) {
            if( document.getElementsByName( key )[0] ) {
                document.getElementsByName( key )[0].value = formValues[key];
            }
        }
    }
}
